import {Component, Inject, OnInit} from '@angular/core';
import {HtmlDocumentControllerService, HtmlDocumentDto, HtmlDocumentTranslationDto,} from '@api/utisha-backend';
import {MessageService} from '../services/message/message.service';
import {LanguageService} from '../services/language.service';
import {
  UT_DIALOG_DATA,
  UtButtonComponent,
  UtDialogContentDirective,
  UtDialogRef,
} from 'src/app/ui';

export class HtmlDocumentDialogData {
  documentId!: number;
}

@Component({
  selector: 'app-conditions',
  templateUrl: './conditions.component.html',
  styleUrls: ['./conditions.component.scss'],
  imports: [
    UtButtonComponent,
    UtDialogContentDirective,
  ],
})
export class ConditionsComponent implements OnInit {
  htmlDocument?: HtmlDocumentDto;
  htmlDocumentTranslation: HtmlDocumentTranslationDto | undefined;
  data: HtmlDocumentDialogData;

  constructor(
    public dialogRef: UtDialogRef<void>,
    private languageService: LanguageService,
    private htmlDocService: HtmlDocumentControllerService,
    private messageService: MessageService,
    @Inject(UT_DIALOG_DATA) data: HtmlDocumentDialogData,
  ) {
    this.data = data;
  }

  ngOnInit(): void {
    this.htmlDocService
      .getHtmlDocument(this.data.documentId)
      .subscribe((doc) => {
        this.htmlDocument = doc;
        this.htmlDocumentTranslation = this.languageService.getTranslation(
          doc.translations || [],
        );
      });
  }

  close(): void {
    this.dialogRef.close();
  }
}
